import React, { Suspense } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { di } from 'react-magnetic-di';

import { IsFhsEnabledProvider } from '@atlaskit/navigation-system/fhs-rollout';
import { queryClient } from '@atlassian/atlassian-studio-api';
import { SentryErrorBoundary, setupSentryClient } from '@atlassian/atlassian-studio-observability';
import { PageMainContentLoadingLogo } from '@atlassian/atlassian-studio-ui-components';
import { AtlassianRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

import { AppSelector } from './AppSelector';
import { WrappedAppSentryErrorFallback } from './WrappedAppSentryErrorFallback';

setupSentryClient({
	packageName: '@atlassian/studio-foundations',
});

export const WrappedApp = (): React.JSX.Element => {
	di(AppSelector, AtlassianRelayEnvironmentProvider);

	return (
		<Suspense
			fallback={<PageMainContentLoadingLogo interactionName="studio-foundations-wrapped-app" />}
		>
			<AtlassianRelayEnvironmentProvider>
				<QueryClientProvider client={queryClient}>
					<SentryErrorBoundary
						fallbackComponent={WrappedAppSentryErrorFallback}
						loggerName="studio.foundations.wrapped-app"
						teamName="studio"
					>
						<IsFhsEnabledProvider value={false}>
							<AppSelector />
						</IsFhsEnabledProvider>
					</SentryErrorBoundary>
				</QueryClientProvider>
			</AtlassianRelayEnvironmentProvider>
		</Suspense>
	);
};
